<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/KQEvuD/media/FC-9781398472723.jpg?1708093998496" alt="This image is the cover for the book Skimmer – Mine"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Skimmer – Mine
      </h1>
      <p class="bookDescription body article font2">
        <p>The Skimmer crew have left the Chinese owned GloberCorpMining mineral Harvester to install a new technology on other Skimmers. However, someone is trying to gain access to the technology that has been developed. The pirates may have been infiltrated by a rogue group. Something has also changed on the Harvester. The Sea Hunters become aware of the evolving situation. Unbeknown to Ngarra’s crew, a super weather cell is developing in “the Area”. Isolated and alone, they must find a way to overcome a standoff and avoid capture. Meanwhile, there is a growing urgency to push ahead with completion of the overdrive trials for the Skimmers. Ngarra’s crew are aware that there is much more to the Skimmers than they are led to believe.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        A.D. Morgan
      </h2>
      
      <p class="authorDescription body article">Andrew has a PhD in environmental and marine science, Grad. Cert. in strategic studies and a Grad. Dip. Ed. He has published in peer-reviewed science journals and co-founded the New Zealand Aquaculture Magazine. Andrew has served as a watch keeping officer in the navy. He has lectured and taught statistics, marine and maritime studies at a technical institute. During this period, he consulted to the fisheries and aquaculture industry. Subsequently, Andrew contracted to the offshore oil and gas industry in environmental management. He then taught secondary school science and mathematics and is a future schools STEM industry focus advocate.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7776a25a